import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import AlfrescoListBlockData from './Data';
import AlfrescoListViewBlock from './View';

const AlfrescoListBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <AlfrescoListViewBlock {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <AlfrescoListBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(AlfrescoListBlockEdit);
